export const FEATURE_FLAGS = {
  LINE_CHART_REPORT: 'lineChartReports',
  DISPLAY_UPCOMING_MAINTENANCE: 'displayUpcomingMaintenance',
  DISABLE_NOTIFICATION_POLLING: 'disableNotificationPolling',
  ENABLE_ASSET_LOCATION: 'enableAssetLocation',
  ENABLE_ASSET_VIEWS: 'enableAssetViews',
  BULK_RESOLVE_ALERTS: 'bulkResolveAlerts',
  ENABLE_AUTO_CASE_LINKING: 'exp-4326_auto_case_linking',
  ENABLE_FLEET_MANAGEMENT_MOCKS: 'exp-4646_fleet_management_mocks',
} as const;
